// import React, { useEffect, useState, useMemo } from 'react';
// import ItemsTable from '../../components/ItemsTable';

// // Column configurations for GRN items
// const COLUMN_CONFIGS = {
//   lineNumber: { label: 'Line No', maxWidth: 100 },
//   grnNumber: { label: 'GRN Number', maxWidth: 150 },
//   asnNumber: { label: 'ASN Number', maxWidth: 150 },
//   skuId: { label: 'SKU ID', maxWidth: 150 },
//   description: { label: 'Description', minWidth: 150, maxWidth: 350 },
//   uom: { label: 'UOM', maxWidth: 100 },
//   lpnNo: { label: 'LPN No', maxWidth: 120 },
//   sourceLocation: { label: 'Source Location', maxWidth: 150 },
//   supplierId: { label: 'Supplier ID', maxWidth: 120 },
//   supplierName: { label: 'Supplier Name', maxWidth: 150 },
//   itemWeight: { label: 'Item Weight', maxWidth: 120 },
//   itemVolume: { label: 'Item Volume', maxWidth: 120 },
//   expectedQty: { label: 'Expected Qty', maxWidth: 130 },
//   receivedQty: { label: 'Received Qty', maxWidth: 130 },
//   onHold: { label: 'On Hold', maxWidth: 100 }
// };

// // Base columns
// const BASE_COLUMNS = [
//   'lineNumber', 'grnNumber', 'asnNumber', 'skuId', 'description', 'uom', 'lpnNo', 
//   'expectedQty', 'receivedQty', 'onHold'
// ];

// // Extra columns for detailed view
// const EXTRA_COLUMNS = [
//   'sourceLocation', 'supplierId', 'supplierName', 
//   'itemWeight', 'itemVolume'
// ];

// // Filter placeholders
// const FILTER_PLACEHOLDERS = {
//   lineNumber: 'Line',
//   skuId: 'SKU',
//   description: 'Desc',
//   uom: 'UOM',
//   lpnNo: 'LPN',
//   expectedQty: 'Exp',
//   receivedQty: 'Recv',
//   onHold: 'Hold'
// };

// export default function DetailsGR({ asnNumber, grnData = [], onClose }) {
//   const [grn, setGrn] = useState(null);



//   useEffect(() => {
//     if (!asnNumber || !grnData.length) return;

//     const found = grnData.find((g) => {
//       // 👇 agar AsnHeader hai to use lo, warna pura object hi header hai
//       const header = g.AsnHeader || g || {};

//       return (
//         header["ASN Number"] === asnNumber ||
//         header["GRN Number"] === asnNumber
//       );
//     });

//     setGrn(found || null);
//   }, [asnNumber, grnData]);


//   const computed = useMemo(() => {
//     if (!grn || !grn.AsnDetail) return { 
//       skuCount: 0, 
//       totalExpected: 0, 
//       totalReceived: 0 
//     };
    
//     const details = grn.AsnDetail || [];
//     const totalExpected = details.reduce((sum, item) => 
//       sum + (item["Expected Qty"] || 0), 0
//     );
//     const totalReceived = details.reduce((sum, item) => 
//       sum + (item["Received Qty"] || 0), 0
//     );
    
//     // Count unique SKU IDs
//     const uniqueSkus = new Set(details.map(item => item["SKU ID"])).size;
    
//     return {
//       skuCount: uniqueSkus,
//       totalExpected,
//       totalReceived
//     };
//   }, [grn]);

//   // Transform AsnDetail data for ItemsTable
//   const searchResults = useMemo(() => {
//     if (!grn || !grn.AsnDetail) return {};
    
//     const map = {};
    
//     // Group by SKU ID
//     grn.AsnDetail.forEach((item, index) => {
//       const skuId = item["SKU ID"] || 'UNKNOWN';
//       const key = `SKU::${skuId}`;
      
//       if (!map[key]) {
//         map[key] = [];
//       }
      
//       // Transform API data to ItemsTable format
//       map[key].push({
//         lineNo: item["Line Number"] || String(index + 1).padStart(5, '0'),
//         lineNumber: item["Line Number"] || String(index + 1).padStart(5, '0'),
//         grnNumber: item["GRN Number"] || '',
//         asnNumber: item["ASN Number"] || '',
//         skuId: item["SKU ID"] || '',
//         item: item["SKU ID"] || '',
//         description: item["Description"] || '',
//         uom: item["UOM"] || 'EA',
//         lpnNo: item["LPN No"] || '',
//         // sourceLocation: item["Source Location"] || '',
//         // supplierId: item["Supplier ID"] || '',
//         // supplierName: item["Supplier Name"] || '',
//         itemWeight: item["Item Weight"] || 0,
//         itemVolume: item["Item Volume"] || 0,
//         expectedQty: item["Expected Qty"] || 0,
//         receivedQty: item["Received Qty"] || 0,
//         onHold: item["On Hold"] || 0,
//         // Add computed fields
//         variance: (item["Received Qty"] || 0) - (item["Expected Qty"] || 0),
//         rowIndex: map[key].length
//       });
//     });
    
//     return map;
//   }, [grn]);

//   // Column configuration
//   const allColumns = useMemo(() => {
//     return [...BASE_COLUMNS, ...EXTRA_COLUMNS];
//   }, []);

//   // Header label formatter
//   const headerLabelFormatter = React.useCallback((groupKey, content) => {
//     return groupKey.startsWith('SKU::') 
//       ? `SKU ID: ${content[0]?.skuId || groupKey.replace('SKU::', '')}` 
//       : groupKey;
//   }, []);

//   // Cell renderer for custom cell content
//   const cellRenderer = React.useCallback((column, row, originalIndex, options) => {
//     const cellData = {
//       lineNumber: row.lineNumber,
//       grnNumber: row.grnNumber,
//       asnNumber: row.asnNumber,
//       skuId: row.skuId,
//       description: row.description,
//       uom: row.uom,
//       lpnNo: row.lpnNo,
//       sourceLocation: row.sourceLocation,
//       supplierId: row.supplierId,
//       supplierName: row.supplierName,
//       itemWeight: row.itemWeight,
//       itemVolume: row.itemVolume,
//       expectedQty: row.expectedQty,
//       receivedQty: row.receivedQty,
//       onHold: row.onHold
//     };

//     return cellData[column] || '-';
//   }, []);

//   // Filter function
//   const filterFunction = React.useCallback((row, originalIndex, filters) => {
//     return Object.entries(filters).every(([key, filterVal]) => {
//       if (!filterVal) return true;
//       const val = row[key];
//       return String(val ?? '').toLowerCase().includes(filterVal.toLowerCase());
//     });
//   }, []);

//   if (!grn) {
//     return (
//       <div className="card shadow-sm">
//         <div className="card-header d-flex justify-content-between align-items-center py-2">
//           <span className="fw-semibold">GRN Details</span>
        
//         </div>
//         <div className="card-body">
//           <div className="text-muted">GRN/ASN not found.</div>
//         </div>
//       </div>
//     );
//   }

//   const header = grn.AsnHeader || grn || {};


//   return (

//    <>
      

//         {/* Header Information */}
//         <div className="row g-3 mb-2">
//           <ReadonlyField label="GRN Number" value={header["GRN Number"]} />
//           <ReadonlyField label="ASN Number" value={header["ASN Number"]} />
//           <ReadonlyField label="Owner" value={header["Owner"]} />
//           <ReadonlyField label="Facility ID" value={header["Facility ID"]} />
//           <ReadonlyField label="Facility Name" value={header["Facility Name"]} />
//           <ReadonlyField label="No. of SKUs" value={computed.skuCount} />
//           <ReadonlyField label="Type" value={header["Type"] === 1 ? 'Standard' : header["Type"]} />
//           <ReadonlyField label="Total Expected Qty" value={computed.totalExpected} />
//           <ReadonlyField label="Total Received Qty" value={computed.totalReceived} />
//           <ReadonlyField label="Total Expected Weight" value={header["Total Expected Weight"]} />
//           <ReadonlyField label="Total Expected Volume" value={header["Total Expected Volume"]} />
//           <ReadonlyField label="Created Date" value={header["Created Date"]} />
//         </div>
      
//         <hr />
        
//         {/* Items Section */}
//         <h6 className="fw-semibold mb-2">Items</h6>
//         {Object.keys(searchResults).length === 0 ? (
//           <div className="text-muted">No item lines found.</div>
//         ) : (
//           <ItemsTable
//             data={searchResults}
//             columns={allColumns}
//             columnConfigs={COLUMN_CONFIGS}
//             filterPlaceholders={FILTER_PLACEHOLDERS}
//             cellRenderer={cellRenderer}
//             headerLabelFormatter={headerLabelFormatter}
//             filterFunction={filterFunction}
//             onCellChange={() => {}} // Read-only for GRN
//             onRemoveGroup={() => {}} // Read-only for GRN
//             onSelectionChange={() => {}} // Read-only for GRN
//             readOnly={true}
//             autoSelectOnInput={false}
//           />
//         )}
//          <div className="d-flex justify-content-center  gap-2 p-3">
//         <button className="btn btn-secondary" onClick={onClose}>Back</button>
//         </div>
  
//   </>
      
//   );
// }

// function ReadonlyField({ label, value }) {
//   return (
//     <div className="col-md-2">
//       <div className="small text-muted fw-semibold">{label}</div>
//       <div className="form-control form-control-sm bg-light">
//         {value ?? '-'}
//       </div>
//     </div>
//   );
// }











// DetailsGR.jsx
import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import ItemsTable from '../../components/ItemsTable';
import { useTranslation } from 'react-i18next';
import { grnTypeLabel } from './grnTypeLabel';
import './goods-receipt.css';

const CATCH_COLUMNS = [
  { key: 'line', labelKey: 'line' },
  { key: 'sourceLine', labelKey: 'sourceLine' },
  { key: 'sku', labelKey: 'sku' },
  { key: 'lpn', labelKey: 'lpn' },
  // { key: 'serial', labelKey: 'serial' },
  { key: 'lot', labelKey: 'lot' },
  { key: 'qty', labelKey: 'qty' },
  { key: 'capture1', labelKey: 'capture1' },
  { key: 'capture2', labelKey: 'capture2' },
  { key: 'weight', labelKey: 'weight' },
];

function catchText(value) {
  if (value == null) return '';
  return String(value).trim();
}

function grnPayload(record) {
  if (!record || typeof record !== 'object') return null;
  if (record.AsnHeader || record.AsnDetail || record['Catch Data']) return record;
  if (record.value?.AsnHeader || record.value?.AsnDetail || record.value?.['Catch Data']) {
    return record.value;
  }
  return record;
}

function readCatchData(grn) {
  if (!grn || typeof grn !== 'object') return [];
  const candidates = [
    grn['Catch Data'],
    grn.catchData,
    grn.CatchData,
    grn.value?.['Catch Data'],
    grn.value?.catchData,
  ];
  return candidates.find(Array.isArray) || [];
}

function mapCatchRows(grn) {
  return readCatchData(grn).map((item, index) => ({
    id: `${catchText(item.LOTXIDKEY)}-${catchText(item.LOTXIDLINENUMBER) || index}`,
    line: catchText(item.LOTXIDLINENUMBER) || String(index + 1).padStart(5, '0'),
    sourceLine: catchText(item.SOURCELINENUMBER),
    sku: catchText(item.SKU),
    lpn: catchText(item.ID),
    serial: catchText(item.SERIALNUMBERLONG),
    lot: catchText(item.LOT),
    qty: item.IQTY ?? '',
    capture1: catchText(item.IOTHER1),
    capture2: catchText(item.IOTHER2),
    weight: item.WGT ?? '',
  }));
}

function displayCatchValue(value) {
  return value === '' || value == null ? '—' : value;
}

// Column configurations for GRN items
const COLUMN_CONFIGS = {
  lineNumber: { label: 'Line No', maxWidth: 100 },
  grnNumber: { label: 'GRN Number', maxWidth: 150 },
  asnNumber: { label: 'ASN Number', maxWidth: 150 },
  skuId: { label: 'SKU ID', maxWidth: 150 },
  description: { label: 'Description', minWidth: 150, maxWidth: 350 },
  uom: { label: 'UOM', maxWidth: 100 },
  lpnNo: { label: 'LPN No', maxWidth: 120 },
  packKey: { label: 'Pack Key', maxWidth: 130 },
  manufacturingDate: { label: 'Manufacturing Date', maxWidth: 140 },
  expirationDate: { label: 'Expiration Date', maxWidth: 140 },
  sourceLocation: { label: 'Source Location', maxWidth: 150 },
  supplierId: { label: 'Supplier ID', maxWidth: 120 },
  supplierName: { label: 'Supplier Name', maxWidth: 150 },
  itemWeight: { label: 'Item Weight', maxWidth: 120 },
  itemVolume: { label: 'Item Volume', maxWidth: 120 },
  expectedQty: { label: 'Expected Qty', maxWidth: 130 },
  receivedQty: { label: 'Received Qty', maxWidth: 130 },
  onHold: { label: 'On Hold', maxWidth: 100 }
};

// Base columns
const BASE_COLUMNS = [
  'lineNumber', 'grnNumber', 'asnNumber', 'skuId', 'description', 'uom', 'lpnNo',
  'expectedQty', 'receivedQty', 'onHold'
];

// Extra columns for detailed view
const EXTRA_COLUMNS = [
  'sourceLocation', 'supplierId', 'supplierName',
  'packKey', 'manufacturingDate', 'expirationDate',
  'itemWeight', 'itemVolume'
];

// Filter placeholders
const FILTER_PLACEHOLDERS = {
  lineNumber: 'Line',
  skuId: 'SKU',
  description: 'Desc',
  uom: 'UOM',
  lpnNo: 'LPN',
  packKey: 'Pack Key',
  manufacturingDate: 'Mfg Date',
  expirationDate: 'Exp Date',
  expectedQty: 'Exp',
  receivedQty: 'Recv',
  onHold: 'Hold'
};

export default function DetailsGR({ asnNumber, grnData = [], onClose }) {
  const { t } = useTranslation();
  const [grn, setGrn] = useState(null);
  const [detailTab, setDetailTab] = useState('details');
  const [catchQuery, setCatchQuery] = useState('');

  useEffect(() => {
    if (!asnNumber || !grnData.length) return;

    const found = grnData.find((g) => {
      const payload = grnPayload(g) || {};
      const header = payload.AsnHeader || payload;
      return (
        header["ASN Number"] === asnNumber ||
        header["GRN Number"] === asnNumber
      );
    });

    setGrn(found ? grnPayload(found) : null);
    setDetailTab('details');
    setCatchQuery('');
  }, [asnNumber, grnData]);

  const computed = useMemo(() => {
    if (!grn || !grn.AsnDetail) return {
      skuCount: 0,
      totalExpected: 0,
      totalReceived: 0
    };

    const details = grn.AsnDetail || [];
    const totalExpected = details.reduce((sum, item) =>
      sum + (item["Expected Qty"] || 0), 0
    );
    const totalReceived = details.reduce((sum, item) =>
      sum + (item["Received Qty"] || 0), 0
    );

    const uniqueSkus = new Set(details.map(item => item["SKU ID"])).size;

    return {
      skuCount: uniqueSkus,
      totalExpected,
      totalReceived
    };
  }, [grn]);

  const searchResults = useMemo(() => {
    if (!grn || !grn.AsnDetail) return {};

    const rows = grn.AsnDetail.map((item, index) => ({
      lineNo: item["Line Number"] || String(index + 1).padStart(5, '0'),
      lineNumber: item["Line Number"] || String(index + 1).padStart(5, '0'),
      grnNumber: item["GRN Number"] || '',
      asnNumber: item["ASN Number"] || '',
      skuId: item["SKU ID"] || '',
      item: item["SKU ID"] || '',
      description: item["Description"] || '',
      uom: item["UOM"] || 'EA',
      lpnNo: item["LPN No"] || '',
      packKey: item["PackKey"] || '',
      manufacturingDate: item["Manufacturing Date"] || '',
      expirationDate: item["Expiration Date"] || '',
      itemWeight: item["Item Weight"] || 0,
      itemVolume: item["Item Volume"] || 0,
      expectedQty: item["Expected Qty"] || 0,
      receivedQty: item["Received Qty"] || 0,
      onHold: item["On Hold"] || 0,
      variance: (item["Received Qty"] || 0) - (item["Expected Qty"] || 0),
      rowIndex: index
    }));

    return rows.length ? { LINES: rows } : {};
  }, [grn]);

  const catchRows = useMemo(() => mapCatchRows(grn), [grn]);

  const visibleCatchRows = useMemo(() => {
    const query = catchQuery.trim().toLowerCase();
    if (!query) return catchRows;
    return catchRows.filter((row) =>
      [row.line, row.sourceLine, row.sku, row.lpn, row.serial, row.lot, row.capture1, row.capture2]
        .some((value) => String(value).toLowerCase().includes(query))
    );
  }, [catchRows, catchQuery]);

  const catchSummary = useMemo(() => {
    const serials = new Set(catchRows.map((row) => row.serial).filter(Boolean));
    const qty = catchRows.reduce((sum, row) => sum + (Number(row.qty) || 0), 0);
    return { count: catchRows.length, serials: serials.size, qty };
  }, [catchRows]);

  const allColumns = useMemo(() => {
    return [...BASE_COLUMNS, ...EXTRA_COLUMNS];
  }, []);

  // Column configs translated
  const translatedColumnConfigs = useMemo(() => {
    const cfg = {};
    Object.keys(COLUMN_CONFIGS).forEach((key) => {
      cfg[key] = {
        ...COLUMN_CONFIGS[key],
        label: t(`goodsReceipt.items.columns.${key}`)
      };
    });
    return cfg;
  }, [t]);

  // Filter placeholders translated
  const translatedFilterPlaceholders = useMemo(() => {
    const obj = {};
    Object.keys(FILTER_PLACEHOLDERS).forEach((key) => {
      obj[key] = t(`goodsReceipt.items.filters.${key}`);
    });
    return obj;
  }, [t]);

  const cellRenderer = React.useCallback((column, row) => {
    const cellData = {
      lineNumber: row.lineNumber,
      grnNumber: row.grnNumber,
      asnNumber: row.asnNumber,
      skuId: row.skuId,
      description: row.description,
      uom: row.uom,
      lpnNo: row.lpnNo,
      packKey: row.packKey,
      manufacturingDate: row.manufacturingDate,
      expirationDate: row.expirationDate,
      sourceLocation: row.sourceLocation,
      supplierId: row.supplierId,
      supplierName: row.supplierName,
      itemWeight: row.itemWeight,
      itemVolume: row.itemVolume,
      expectedQty: row.expectedQty,
      receivedQty: row.receivedQty,
      onHold: row.onHold
    };

    return cellData[column] || '-';
  }, []);

  const filterFunction = React.useCallback((row, originalIndex, filters) => {
    return Object.entries(filters).every(([key, filterVal]) => {
      if (!filterVal) return true;
      const val = row[key];
      return String(val ?? '').toLowerCase().includes(filterVal.toLowerCase());
    });
  }, []);

  if (!grn) {
    return (
      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center py-2">
          <span className="fw-semibold">
            {t("goodsReceipt.header.grnDetails")}
          </span>
        </div>
        <div className="card-body">
          <div className="text-muted">
            {t("goodsReceipt.header.notFound")}
          </div>
        </div>
      </div>
    );
  }

  const header = grn.AsnHeader || grn || {};

  return (
    <>
      <ul className="nav nav-tabs pp-entity-tabs grn-detail-tabs mb-3" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            type="button"
            role="tab"
            aria-selected={detailTab === 'details'}
            className={`nav-link ${detailTab === 'details' ? 'active' : ''}`}
            onClick={() => setDetailTab('details')}
          >
            <i className="bi bi-receipt me-1" aria-hidden />
            {t('goodsReceipt.tabs.grnDetails')}
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            type="button"
            role="tab"
            aria-selected={detailTab === 'catch'}
            className={`nav-link ${detailTab === 'catch' ? 'active' : ''}`}
            onClick={() => setDetailTab('catch')}
          >
            <i className="bi bi-upc-scan me-1" aria-hidden />
            {t('goodsReceipt.tabs.catchData')}
            <span className="grn-catch-count">{catchSummary.count}</span>
          </button>
        </li>
      </ul>

      {detailTab === 'details' && (
      <>
      {/* Header Information */}
      <div className="row g-3 mb-2">
        <ReadonlyField label={t("goodsReceipt.fields.grnNumber")} value={header["GRN Number"]} />
        <ReadonlyField label={t("goodsReceipt.fields.asnNumber")} value={header["ASN Number"]} />
        <ReadonlyField label={t("goodsReceipt.fields.owner")} value={header["Owner"]} />
        <ReadonlyField label={t("goodsReceipt.fields.facilityId")} value={header["Facility ID"]} />
        <ReadonlyField label={t("goodsReceipt.fields.facilityName")} value={header["Facility Name"]} />
        <ReadonlyField label={t("goodsReceipt.fields.skuCount")} value={computed.skuCount} />
        <ReadonlyField
          label={t("goodsReceipt.fields.type")}
          value={grnTypeLabel(header["Type"], t)}
        />
        <ReadonlyField label={t("goodsReceipt.fields.totalExpectedQty")} value={computed.totalExpected} />
        <ReadonlyField label={t("goodsReceipt.fields.totalReceivedQty")} value={computed.totalReceived} />
        <ReadonlyField label={t("goodsReceipt.fields.totalExpectedWeight")} value={header["Total Expected Weight"]} />
        <ReadonlyField label={t("goodsReceipt.fields.totalExpectedVolume")} value={header["Total Expected Volume"]} />
        <ReadonlyField label={t("goodsReceipt.fields.createdDate")} value={header["Created Date"]} />
      </div>

      <hr />

      {/* Items Section */}
      <h6 className="fw-semibold mb-2">
        {t("goodsReceipt.header.items")}
      </h6>
      {Object.keys(searchResults).length === 0 ? (
        <div className="text-muted">
          {t("goodsReceipt.items.noItems")}
        </div>
      ) : (
        <ItemsTable
          data={searchResults}
          columns={allColumns}
          columnConfigs={translatedColumnConfigs}
          filterPlaceholders={translatedFilterPlaceholders}
          cellRenderer={cellRenderer}
          filterFunction={filterFunction}
          hideGroupHeader
          resizableColumns
          onCellChange={() => { }}
          onRemoveGroup={() => { }}
          onSelectionChange={() => { }}
          readOnly={true}
          autoSelectOnInput={false}
        />
      )}
      </>
      )}

      {detailTab === 'catch' && (
        <CatchDataPanel
          rows={visibleCatchRows}
          total={catchSummary.count}
          summary={catchSummary}
          query={catchQuery}
          onQueryChange={setCatchQuery}
          t={t}
        />
      )}

      <div className="d-flex justify-content-center gap-2 p-3">
        <button className="btn btn-secondary" onClick={onClose}>
          {t("goodsReceipt.buttons.back")}
        </button>
      </div>
    </>
  );
}

const CATCH_COL_MIN = 64;
const CATCH_COL_MAX = 900;

function fitCatchColumnWidth(label, rows, key) {
  let longestValue = 0;
  rows.forEach((row) => {
    const value = row?.[key];
    if (value != null && value !== '' && value !== '—') {
      longestValue = Math.max(longestValue, String(value).length);
    }
  });
  const headerWidth = String(label || '').length * 10 + 56;
  const valueWidth = longestValue * 8.5 + 40;
  return Math.max(110, Math.min(Math.max(headerWidth, valueWidth), 420));
}

function CatchDataPanel({ rows, total, summary, query, onQueryChange, t }) {
  const [columnWidths, setColumnWidths] = useState(() => Object.fromEntries(
    CATCH_COLUMNS.map((column) => [
      column.key,
      fitCatchColumnWidth(t(`goodsReceipt.catchData.columns.${column.labelKey}`), rows, column.key),
    ])
  ));
  const columnWidthsRef = useRef(columnWidths);
  columnWidthsRef.current = columnWidths;

  useEffect(() => {
    setColumnWidths((prev) => {
      const next = { ...prev };
      let changed = false;
      CATCH_COLUMNS.forEach((column) => {
        if (next[column.key] == null) {
          next[column.key] = fitCatchColumnWidth(
            t(`goodsReceipt.catchData.columns.${column.labelKey}`),
            rows,
            column.key
          );
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  }, [rows, t]);

  const startResize = useCallback((columnKey, event) => {
    event.preventDefault();
    event.stopPropagation();
    const handle = event.currentTarget;
    const startX = event.clientX;
    const startWidth = columnWidthsRef.current[columnKey] || CATCH_COL_MIN;
    handle.classList.add('is-active');
    const previousCursor = document.body.style.cursor;
    const previousSelect = document.body.style.userSelect;
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';

    const onMove = (moveEvent) => {
      const next = Math.min(
        CATCH_COL_MAX,
        Math.max(CATCH_COL_MIN, startWidth + (moveEvent.clientX - startX))
      );
      setColumnWidths((prev) => (
        prev[columnKey] === next ? prev : { ...prev, [columnKey]: next }
      ));
    };

    const onUp = () => {
      handle.classList.remove('is-active');
      document.body.style.cursor = previousCursor;
      document.body.style.userSelect = previousSelect;
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
    };

    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
  }, []);

  const tableWidth = CATCH_COLUMNS.reduce((sum, column) => {
    const label = t(`goodsReceipt.catchData.columns.${column.labelKey}`);
    return sum + (columnWidths[column.key] || fitCatchColumnWidth(label, rows, column.key));
  }, 0);

  return (
    <section className="grn-catch">
      <div className="grn-catch-summary">
        <div>
          <span>{t('goodsReceipt.catchData.records')}</span>
          <strong>{summary.count}</strong>
        </div>
        <div>
          <span>{t('goodsReceipt.catchData.serials')}</span>
          <strong>{summary.serials}</strong>
        </div>
        <div>
          <span>{t('goodsReceipt.catchData.totalQty')}</span>
          <strong>{summary.qty}</strong>
        </div>
      </div>

      <div className="grn-catch-toolbar">
        <label className="grn-catch-search">
          <i className="bi bi-search" aria-hidden />
          <input
            type="search"
            value={query}
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder={t('goodsReceipt.catchData.search')}
            aria-label={t('goodsReceipt.catchData.search')}
          />
        </label>
        <span className="grn-catch-shown">
          {t('goodsReceipt.catchData.showing', { shown: rows.length, total })}
        </span>
      </div>

      {rows.length === 0 ? (
        <div className="grn-catch-empty">
          <i className="bi bi-inbox" aria-hidden />
          <p>{query ? t('goodsReceipt.catchData.noMatch') : t('goodsReceipt.catchData.empty')}</p>
        </div>
      ) : (
        <div className="grn-catch-table-wrap">
          <table
            className="grn-catch-table"
            style={{ width: tableWidth, minWidth: tableWidth }}
          >
            <colgroup>
              {CATCH_COLUMNS.map((column) => (
                <col key={column.key} style={{ width: columnWidths[column.key] }} />
              ))}
            </colgroup>
            <thead>
              <tr>
                {CATCH_COLUMNS.map((column) => {
                  const label = t(`goodsReceipt.catchData.columns.${column.labelKey}`);
                  return (
                    <th
                      key={column.key}
                      className={column.numeric ? 'is-numeric' : undefined}
                      title={label}
                    >
                      <span className="grn-catch-th-label">{label}</span>
                      <span
                        className="grn-catch-col-resizer"
                        onPointerDown={(event) => startResize(column.key, event)}
                      />
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  {CATCH_COLUMNS.map((column) => {
                    const value = column.key === 'serial' && row.serial
                      ? row.serial
                      : displayCatchValue(row[column.key]);
                    return (
                      <td
                        key={column.key}
                        title={value === '—' ? undefined : String(value)}
                        className={[
                          column.numeric ? 'is-numeric' : '',
                          column.key === 'serial' ? 'is-serial' : '',
                        ].filter(Boolean).join(' ') || undefined}
                      >
                        {column.key === 'serial' && row.serial ? (
                          <span className="grn-catch-serial">{row.serial}</span>
                        ) : (
                          value
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}

function ReadonlyField({ label, value }) {
  return (
    <div className="col-md-2">
      <div className="small text-muted fw-semibold">{label}</div>
      <div className="form-control form-control-sm bg-light">
        {value ?? '-'}
      </div>
    </div>
  );
}
